import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { SchoolAgenda } from './../../../models/school-agenda';
import { Client } from './../../../models/client';
import { School } from './../../../models/school';
import { zoneOfservice } from './../../../models/zoneOfService';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;


@Component({
  selector: 'app-school-edit',
  templateUrl: './school-edit.component.html',
  styleUrls: ['./school-edit.component.css']
})
export class SchoolEditComponent implements OnInit {

  school: School;
  clients: any[];
  cityWeathers: any[];
  schoolAgendas: any[];
  zonesOfService: any;
  directionsService: any;
  directionsRenderer: any;
  selectedZoneIndex: any;
  firstPolygon: any;
  drawingManager: any;
  drawingZoneActive: boolean = false;
  drawingVertices: any[] = [];
  drawingPolygon: any = null;
  days: {};
  isAdmin: boolean;
  map: any;
  mapZonesOfService: any;
  packType: any = '3';
  schoolMarker: any;
  buses: any[] = [];
  oldzonesOfService: any[];


  public clientsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  public cityWeatherData: Array<Select2OptionData>;
  pnotify = undefined;

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
  };
  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------

  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.school = new School();
    this.schoolAgendas = [
      new SchoolAgenda('1'),
      new SchoolAgenda('2'),
      new SchoolAgenda('3'),
      new SchoolAgenda('4'),
      new SchoolAgenda('5')
    ];
    this.schoolAgendas[0].day = '1';
    this.days = {
      1: 'Lundi',
      2: 'Mardi',
      3: 'Mercredi',
      4: 'Jeudi',
      5: 'Vendredi'
    };
    this.route.params.subscribe(params => {
      this.http.get(
        '/api/school/' + params['id']
      ).subscribe((school: any) => {
        if (
          (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
          && this.authService.getUser().id !== school.clientId
        ) {
          this.router.navigate(['']);
        }
        this.school = school;
        //this.zonesOfService = this.school.zonesOfService;

        this.filter.clientId = school.clientId;
        this.filter.schoolId = school.id;
        this.initMap();
        this.initBusSelect();

        if (school.hasOwnProperty('SchoolAgendas')) {
          for (let i = 0; i < school.SchoolAgendas.length; i++) {
            this.schoolAgendas[school.SchoolAgendas[i].day - 1] = school.SchoolAgendas[i];
          }
        }
        this.loadCityWeathers();
      });
    });
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.http.get<any[]>(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map((client, index) => {
          return { id: client.id, text: client.name, selected: (client.id == this.school.clientId) ? true : false };
        });
        this.clientsData = array1.concat(array2);
      });
    }
    this.pnotify = pnotifyService.getPNotify();
  }

  clientChanged(e: any) {
    this.school.clientId = e.value;
    const selectedClient = this.clients.find(client => {
      return client.id == e.value;
    });

    // Check if the client is found and has a packType property
    if (selectedClient) {
      this.packType = selectedClient.pack;
    } else {
      this.packType = '3';
    }
  }

  cityWeatherChanged(e: any) {
    this.school.cityWeatherId = e.value;
  }

  loadCityWeathers() {
    this.http.get<any[]>('/api/cityWeather/lookup').subscribe((cityWeathers) => {
      this.cityWeathers = cityWeathers;
      this.cityWeatherData = cityWeathers.map((cw) => ({
        id: cw.id,
        text: cw.cityName,
        selected: (cw.id == this.school.cityWeatherId)
      }));
    });
  }

  addCity() {
    const cityName = prompt('Nom de la nouvelle ville :');
    if (!cityName || !cityName.trim()) return;
    this.http.post('/api/cityWeather', { cityName: cityName.trim() }).subscribe((newCity: any) => {
      this.loadCityWeathers();
      setTimeout(() => {
        this.school.cityWeatherId = newCity.id;
        this.cityWeatherData = this.cityWeathers.map((cw) => ({
          id: cw.id,
          text: cw.cityName,
          selected: (cw.id == newCity.id)
        }));
      }, 300);
    }, () => {
      this.pnotify.error({ title: 'Erreur', text: 'Impossible d\'ajouter la ville.', delay: 3000 });
    });
  }

  ngOnInit() {
  }

  initMap() {
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 31.585832, lng: -6.183891 };
    let option = {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), option);
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.placeMarker(event);
    });
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      draggable: true,
      zIndex: 100,
    });
  }

  initMapZoneOfService(index) {
    
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 31.585832, lng: -6.183891 };

    this.selectedZoneIndex  = index;
    this.directionsService    = new google.maps.DirectionsService;
    this.directionsRenderer   = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    let option = {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    
    this.mapZonesOfService = new google.maps.Map(document.getElementById('zone-map'), option);
    this.directionsRenderer.setMap(this.mapZonesOfService);
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.mapZonesOfService,
      icon: 'assets/images/markers/school.png',
      draggable: true,
      zIndex: 100,
    });


    // show all polygons in the map
    for (let i = 0; i < this.school.zonesOfService.length; i++) {
      const zone = this.school.zonesOfService[i];

      // for Dynamic Zone
      if (zone.coordZone != 0 && zone.coordZone != null){
        // Parse the JSON string into an array of coordinates
        let storedCoordinates;
        try {
          storedCoordinates = JSON.parse(zone.coordZone) as { lat: number, lng: number }[];
        } catch (e) {
          continue;
        }

        let editDrawingCmd;

        if (this.selectedZoneIndex === -1) {
          editDrawingCmd = false;
        } else if (i === this.selectedZoneIndex) {
          editDrawingCmd = true;
        } else {
          editDrawingCmd = false;
        }

        // Draw the saved polygon on the map
        this.drawSavedPolygon(storedCoordinates, this.getZoneColor(zone), editDrawingCmd);
      }
    }
  }

  addMapZoneOfService() {

    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 31.585832, lng: -6.183891 };

    this.directionsService    = new google.maps.DirectionsService;
    this.directionsRenderer   = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    let option = {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    
    this.mapZonesOfService = new google.maps.Map(document.getElementById('zone-map'), option);
    this.directionsRenderer.setMap(this.mapZonesOfService);
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.mapZonesOfService,
      icon: 'assets/images/markers/school.png',
      draggable: true,
      zIndex: 100,
    });


    // show all polygons in the map
    for (let i = 0; i < this.school.zonesOfService.length-1; i++) {
      const zone = this.school.zonesOfService[i];

      // for Dynamic Zone
      if (zone.coordZone != 0 && zone.coordZone != null){
        // Parse the JSON string into an array of coordinates
        let storedCoordinates;
        try {
          storedCoordinates = JSON.parse(zone.coordZone) as { lat: number, lng: number }[];
        } catch (e) {
          continue;
        }

        // Draw the saved polygon on the map
        this.drawSavedPolygon(storedCoordinates, this.getZoneColor(zone), false);
      }
    }

    // Custom polygon drawing (DrawingManager was removed in Maps JS API v3.65)
    this.drawingZoneActive = true;
    this.drawingVertices = [];
    this.drawingPolygon = null;

    google.maps.event.addListener(this.mapZonesOfService, 'click', (event) => {
      this.addDrawingVertex(event.latLng);
    });

  }

 // Function to draw a polygon on the map
  drawSavedPolygon(coordinates: { lat: number, lng: number }[],color,editDrawingCmd) {
    const polygon = new google.maps.Polygon({
      paths: coordinates,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.35,
      editable: editDrawingCmd, // You can set this to false if you don't want the polygon to be editable
      map: this.mapZonesOfService
    });

    // Add event listeners for polygon modification
    google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
      this.handlePolygonModification();
    });

    google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
      this.handlePolygonModification();
    });

    // Save only polygon that is editable
    if (editDrawingCmd === true) {
      this.firstPolygon = polygon;
    }
  }

  addDrawingVertex(latLng) {
    if (!this.drawingZoneActive) return;
    this.drawingVertices.push({ lat: latLng.lat(), lng: latLng.lng() });

    if (!this.drawingPolygon) {
      this.drawingPolygon = new google.maps.Polygon({
        paths: this.drawingVertices,
        strokeColor: 'blue',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'blue',
        fillOpacity: 0.35,
        editable: false,
        map: this.mapZonesOfService,
      });
    } else {
      this.drawingPolygon.setPath(this.drawingVertices);
    }
  }

  finishDrawingZone() {
    if (!this.drawingZoneActive) return;
    this.drawingZoneActive = false;

    if (this.drawingVertices.length < 3) {
      // Not enough points to form a polygon
      if (this.drawingPolygon) {
        this.drawingPolygon.setMap(null);
      }
      this.drawingPolygon = null;
      this.drawingVertices = [];
      return;
    }

    // Store the polygon path in the new zone's data model
    const coordinatesString = JSON.stringify(this.drawingVertices);
    const zoneIndex = this.school.zonesOfService.length - 1;
    this.school.zonesOfService[zoneIndex].coordZone = coordinatesString;
    this.selectedZoneIndex = zoneIndex;

    // Make the polygon editable and save a reference to it
    this.drawingPolygon.setEditable(true);
    this.firstPolygon = this.drawingPolygon;

    // Add event listeners for polygon modification
    google.maps.event.addListener(this.firstPolygon.getPath(), 'set_at', () => {
      this.handlePolygonModification();
    });

    google.maps.event.addListener(this.firstPolygon.getPath(), 'insert_at', () => {
      this.handlePolygonModification();
    });

    this.drawingPolygon = null;
    this.drawingVertices = [];
  }

  handlePolygonModification() {
    // This function is called when the polygon is modified (vertex is moved or inserted)
    //console.log('Polygon modification completed');
    // Add your logic here
    // Store the polygon path in your data model
    const path = this.firstPolygon.getPath();
    const coordinates = path.getArray().map(coord => ({ lat: coord.lat(), lng: coord.lng() }));
  
    // Convert the coordinates array to a JSON string
    const coordinatesString = JSON.stringify(coordinates);

    // Update your data model with the coordinates
    this.school.zonesOfService[this.selectedZoneIndex].coordZone = coordinatesString;
  }

  placeMarker(event) {
    if (!this.schoolMarker){
      this.schoolMarker = new google.maps.Marker({
        position: event.latLng,
        map: this.map,
        icon: 'assets/images/markers/school.png',
        draggable: true,
        zIndex: 100,
      });
      this.school.lat = event.latLng.lat();
      this.school.lng = event.latLng.lng();
      google.maps.event.addListener(this.schoolMarker, 'dragend', (e) => {
        this.school.lat = e.latLng.lat();
        this.school.lng = e.latLng.lng();
      });
    }
  }

  

  /* initZonesOfService() {
    let params = new HttpParams({
      fromObject: {
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/school/lookupZoneOfService',
      { params }
    ).subscribe((zonesOfservice: any[]) => {
      this.zonesOfService = zonesOfservice;
    });
  } */

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get<any[]>(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      // no need for below code
      const array1 = [{ id: '', text: 'Choisir le bus de service' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name};
      });
      this.busesData = array1.concat(array2);
    });
  }

  onDateChange(event) {
    const selectedYear = event.year(); 
    const subscriptionYear = `${selectedYear}/${selectedYear + 1}`;

    // Update the school subscription year
    this.school.subscriptionSchoolYear = subscriptionYear;
  }

  updateDaySlot(day, slot, $event) {
    this.schoolAgendas[day - 1][slot + 'Start'] = moment($event.from * 1000).format('HH:mm');
    this.schoolAgendas[day - 1][slot + 'End'] = moment($event.to * 1000).format('HH:mm');
    //console.log ("schoolAgendas : ",this.schoolAgendas[day - 1][slot + 'Start']);
    //console.log ("schoolAgendas : ",this.schoolAgendas[day - 1][slot + 'Start']);
  }

  
  updateZoneOfServiceBus(zoneOfServiceBusId: any,index) {
    this.school.zonesOfService[index].busId = zoneOfServiceBusId;
    const bus = (this.buses || []).find(bus => bus.id == zoneOfServiceBusId);
    this.school.zonesOfService[index].Bus = bus;
  }

  getBusColor(zoneOfServiceBusId: string): string {
    if (!this.buses) return '';
    const bus = this.buses.find(bus => bus.id == zoneOfServiceBusId);
    return bus ? bus.colorLineBus : '';
  }

  getZoneColor(zone: any): string {
    return (zone && zone.Bus && zone.Bus.colorLineBus) ? zone.Bus.colorLineBus : 'blue';
  }

  addNewZoneOfService(){
    const newZoneOfService = new zoneOfservice();
    // Initialize required fields
    newZoneOfService.schoolId = this.school.id; 
    newZoneOfService.coordZone = ''; 
    this.school.zonesOfService.push(newZoneOfService);
    $('#ModalZones').modal('show');
    setTimeout(() => {
      this.addMapZoneOfService();
    }, 500);

  }

  editZoneOfService(index){
    $('#ModalZones').modal('show');
    setTimeout(() => {
      this.initMapZoneOfService(index);
    }, 500);
  }

  removeZoneOfService(index){

    let tmpzonesOfService = [];
    while (index < this.school.zonesOfService.length - 1) {
      tmpzonesOfService.unshift(this.school.zonesOfService.pop());
    }
    if (index == this.school.zonesOfService.length - 1) {
      this.school.zonesOfService.pop();
    }
    setTimeout(() => {
      while (tmpzonesOfService.length) {
        this.school.zonesOfService.push(tmpzonesOfService.shift());
      }
    }, 10);

  }

  showAllZonesOfService(){
    $('#ModalZones').modal('show');
    setTimeout(() => {
      this.initMapZoneOfService(-1);
    }, 500);
  }
  
  // not used
  updateZoneOfServiceName(value: string, index: number) {
    this.school.zonesOfService[index].name = value;
  }

  onArchive() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous archiver tous les passagers non inscrits ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.archiveOldPassagers();
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  archiveOldPassagers() {
    //BTN Archive => UPDATE `passager` SET `isActive`= 0 WHERE `IDEcole` = 19 AND `isActive`= 1 AND `inscriptionType`= '-'
      this.http
        .put(
          '/api/school/archiveAllPassagers/' + this.school.id,
          { school: this.school, }
        )
        .subscribe(
          result => {
            this.pnotify.notice({
              title: 'Notification',
              text: 'Opération terminée',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: (notice) => {
                        notice.close();
                        notice.fire('pnotify.cancel', { notice });
                      }
                    }
                  ]
                }
              }
            });
          },
          error => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
  }

  onValide() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous valider tous les passagers inscrits ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.valideNewPassagers();
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  valideNewPassagers() {
    //BTN valide => UPDATE `passager` SET `inscriptionType`= '-' WHERE `IDEcole` = 19 AND (`inscriptionType`= 'new' OR `inscriptionType`= 'renew' ) AND `isActive`= 1
    this.http
    .put(
      '/api/school/valideNewPassagers/' + this.school.id,
      { school: this.school, }
    )
    .subscribe(
      result => {
        this.pnotify.notice({
          title: 'Notification',
          text: 'Opération terminée',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: (notice) => {
                    notice.close();
                    notice.fire('pnotify.cancel', { notice });
                  }
                }
              ]
            }
          }
        });
      },
      error => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );

  }

  onSubmit(): void {
    //this.school.creationDate = moment(this.school.creationDate).format('YYYY-MM-DD HH:mm:ss');
    this.http.put<School>(
      '/api/school/' + this.school.id,
      {
        school: this.school,
      }
    ).subscribe(
      (school: School) => {
        this.school = school;
        this.router.navigate(['/school/view', this.school.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/school/school-edit/school-edit.component.ts